import React from 'react';
import PropTypes from 'prop-types';

import { forms as Forms } from '@breezeway/brzw-components';

const FormControlCounterInput = ({
  input: { onChange, value },
  meta: { error },
  id,
  label,
  maxValue,
  minValue,
  placeholder,
  required,
  type,
}) => (
  <Forms.CounterInput
    id={id}
    isRequired={required}
    labelText={label}
    maxValue={maxValue}
    minValue={minValue}
    onChange={onChange}
    placeholderText={placeholder}
    type={type}
    value={value}
    withError={error}
  />
);

FormControlCounterInput.propTypes = {
  id: PropTypes.string,
  input: PropTypes.shape({}),
  label: PropTypes.string,
  meta: PropTypes.shape({}),
  maxValue: PropTypes.number,
  minValue: PropTypes.number,
  placeholder: PropTypes.string,
  required: PropTypes.bool,
  type: PropTypes.string,
};

export default FormControlCounterInput;
